// extracted by mini-css-extract-plugin
module.exports = {"buildcontrol":"buildcontrol_buildcontrol__Z5Co7","label":"buildcontrol_label__2p98L","less":"buildcontrol_less__2hQxd","more":"buildcontrol_more__2aKqf"};